import { Modal } from 'rsuite'
import SearchByKeyword from '@/components/publications/searchByKeyword'
import SearchByKeywordNordics from '@/components/themes/subaru-nordics/publications/searchByKeyword'
import useTranslation from '@/hooks/useTranslation'
import style from './desktopHeader.module.scss'
import { customerHelper } from '@tweddle-se-team/common/constants'
import { customerId } from '@/utils/env'
import { useIsMobile } from '@/hooks/useIsMobile'

const { CUSTOMER_IDS } = customerHelper

const SearchByKeywordByCustomer = {
  [CUSTOMER_IDS.SUBARU]: SearchByKeyword,
  [CUSTOMER_IDS.TME]: SearchByKeyword,
  [CUSTOMER_IDS.NORDICS]: SearchByKeywordNordics
}

const searchModalSizeByCustomer = {
  [CUSTOMER_IDS.SUBARU]: () => undefined,
  [CUSTOMER_IDS.TME]: () => undefined,
  [CUSTOMER_IDS.NORDICS]: ({ isMobile }) => (isMobile ? 'full' : undefined)
}

function SearchModal({ open, onClose, brand, model, modelType, year, language }) {
  const t = useTranslation()
  const isMobile = useIsMobile()
  const SearchByKeywordComponent = SearchByKeywordByCustomer[customerId] || SearchByKeyword
  const getModalSize = searchModalSizeByCustomer[customerId] || searchModalSizeByCustomer[CUSTOMER_IDS.TME]
  const modalSize = getModalSize({ isMobile })

  return (
    <Modal open={open} onClose={onClose} size={modalSize} className="subaru-search-modal">
      <Modal.Header>
        <Modal.Title className={style.searchModalTitle} as="h2">
          {t('header_search', 'Search')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <SearchByKeywordComponent
          brand={brand}
          model={model}
          modelType={modelType}
          year={year}
          language={language}
          closeWrapper={onClose}
        />
      </Modal.Body>
    </Modal>
  )
}

export default SearchModal
